var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{attrs:{"no-padding":true}},[_c('com-summary'),_c('com-selection'),_c('com-save'),_c('com-info'),_c('com-foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }